import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ModalService } from '../../shared/services/modal.service';
import { DataLayerService } from '../../../core/services/data-layer.service';

@Component({
  selector: 'app-cookies-page',
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule],
  providers: [ModalService],
  templateUrl: './cookies-page.component.html',
  styleUrl: './cookies-page.component.scss',
})
export class CookiesPageComponent {
  modalService = inject(ModalService);
  cookieService = inject(CookieService);
  private readonly _dataLayerService = inject(DataLayerService);
  screenName = 'cookies-page';

  browserChrome: string = "http://support.google.com/chrome/bin/answer.py?hl=es&answer=95647";
  browserEdge: string = "https://support.microsoft.com/es-es/help/4468242/microsoft-edge-browsing-data-and-privacy";
  browserIe: string = "http://windows.microsoft.com/es-es/internet-explorer/delete-manage-cookies";
  browserFirefox: string = "http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we";
  browserSafari: string = "http://support.apple.com/kb/HT1677?viewlocale=es_ES";
  browserOpera: string = "http://help.opera.com/Windows/8.54/es-ES/cookies.html#privacy-cookie";

  ngOnInit(): void {
    this._dataLayerService.pushEventPageView(this.screenName);
  }
}
